import { useQuery } from '@tanstack/react-query';
import { ExportersApi } from 'api';

/**
 *  Custom React Query hook for fetching sellers
 *
 * @param {{page: number, perPage: number, order: string, orderBy: string}} queryObj
 * @param {{ enabled?: boolean }} options
 * @returns {import('@tanstack/react-query').UseQueryResult}
 */
export function useGetExporters(queryObj, { enabled = true } = {}) {
  return useQuery({
    queryKey: ['exporters', queryObj],
    queryFn: () => ExportersApi.search(queryObj).then((res) => res.data),
    enabled: !!queryObj && enabled,
  });
}
